import { domains } from 'config/env'
import { createApiClient } from 'lib/Api'

const baseApiAddress = `${domains.REPORTING_API}`

const api = (function(baseApiAddress) {
  const _api = createApiClient(baseApiAddress)

  // Add timeout for reporting API
  _api.defaults.timeout = 60000

  const GET_SITE_USERS = siteId => ({
    query: `
      query GetSiteUsers {
        SiteUsers(siteId: ${siteId}) {
          users {
            email
            classCount
          }
        }
      }
    `,
  })

  return {
    getSiteUsers: async siteId => {
      return _api.post(baseApiAddress, GET_SITE_USERS(siteId))
    },
  }
})(baseApiAddress, true)

export default api
